module.exports = __webpack_public_path__ + "static/media/hawk.1aa319f8.svg";